import { makeAutoObservable } from "mobx"
import { DragDropFile } from "react-sdk/activities/DragDrop"
import { QCMFile } from "react-sdk/activities/QCM"
import { SwipeFile } from "react-sdk/activities/Swipe"
import Analytics from "react-sdk/Vertx/Analytics"
import AppState, { POPUPS } from "../AppState"
import Minigame from "./Minigame"
import DataManager, { DataUtils } from "react-sdk/haxelibs/DataManager"

export const MG_TYPES = {
  QUIZ: "quiz",
  DRAGDROP: "dragdrop",
  DRAGDROP_IMAGE: "dragdrop_image",
  SWIPE: "swipe"
}

class Minigames {
  /** @type {QCMFile} */
  qcms = null

  /** @type {DragDropFile} */
  dragdrops = null

  /** @type {DragDropFile} */
  dragdrops_image = null

  /** @type {SwipeFile} */
  swipes = null

  /** @type {Array<Minigame>} */
  all = []


  currentLevelIndex = null
  /** @type {Minigame} */
  current = null

  /**
   * Pour contenir un MG qui représente un groupe de MG
   * @type {Minigame}
   */
  currentGroup = null

  onEnd = null

  history = []
  constructor() {
    makeAutoObservable(this)
  }

  /**
   *
   * @param {String} minigamesFilename
   */
  init(minigamesFilename, files) {

    let {
      qcms,
      dragdrops,
      dragdrops_image,
      swipe
    } = files

    this.qcms = new QCMFile(qcms)
    this.qcms.observeAll()

    this.dragdrops = new DragDropFile(dragdrops)
    this.dragdrops.observeAll()

    this.dragdrops_image = new DragDropFile(dragdrops_image)
    this.dragdrops_image.observeAll()

    this.swipes = new SwipeFile(swipe)
    this.swipes.observeAll()



    let minigames = DataManager.getFile(minigamesFilename);

    this.all = minigames.lines.filter(line => line.id).map(line => new Minigame(line))

    this.all.forEach(mg => {
      let c = DataUtils.getChildren(mg.line, "parent");
      if (c && c.length > 0) {
        mg.children = c.map(childLine => this.get(childLine.id))
      }
    })
  }

  get ids() {
    return this.all.map(c => c.id)
  }

  get(id) {
    return this.all.find(c => c.id === id)
  }

  get unlocked() {
    return this.all.filter(mg => mg.unlocked)
  }

  /**
   *
   * @param {string} id l'id de la ligne principale du mg dans le .data
   * @param {Function} onFinished callback appelée à la fin du mg
   */
  play(id, onFinished) {
    this.onEnd = onFinished

    let mg = this.get(id)

    if(!mg) {
      throw new Error(`Minigame ${id} does not exist`)
    }

    this.launch(mg)
  }

  skipAutoWin(id) {
    let mg = this.get(id)

    if(mg) {
      if (mg.isContainer()) {
        mg.children.forEach((childMg) => {
          childMg.setScore(1)
        })
      } else
        mg.setScore(1)

    }
  }

  /**
   *
   * @param {Minigame} minigame le minigame à lancer
   * @param {Function} onfinished callback appelée à la fin du mg
   */
  launch(minigame) {

    console.log(minigame)

    if (minigame.isContainer()) {
      this.currentGroup = minigame
      this.launchNextInGroup()
    } else {
      this.reallyLaunch(minigame)
    }
  }

  launchNextInGroup() {
    let currIndex = -1;
    if (this.current)
      currIndex = this.currentGroup.findCurrentMinigameIndex(this.current)

    ++currIndex;
    if (currIndex >= this.currentGroup.children.length) {
      this.history.push(this.currentGroup)
      this.currentGroup = null;
      this.current = null;
      if (this.onEnd) {
        let tmp = this.onEnd
        this.onEnd = null
        tmp()
      }
    } else {
      this.launch(this.currentGroup.children[currIndex])
    }

  }

  reallyLaunch(minigame) {
    this.current = minigame
    Analytics.changeScreenEvents(null, "popup.MINIGAME." + this.current.id)
  }

  stop() {
    if (this.current) {
      if (this.current.elementRef?.result?.normalized_score)
        this.current.setScore(this.current.elementRef.result.normalized_score)
      else
        this.current.setScore(0)
      Analytics.changeScreenEvents("popup.MINIGAME." + this.current.id)
    }

    if (this.currentGroup) {
      this.launchNextInGroup();
    } else {
      this.history.push(this.current)
      this.current = null;
      if (this.onEnd) {
        let tmp = this.onEnd
        this.onEnd = null
        tmp()
      }
    }
  }

  /*stateToJson() {
    return this.all.map(mg => {
      return {
        id: mg.id,
        unlocked: mg.unlocked,
        levels: mg.levels.map(l => ({
          id: l.id,
          stars: l.stars,
          unlocked: l.unlocked,
          playCount: l.playCount,
        })),
      }
    })
  }
  stateFromJson(data) {
    data.forEach(d => {
      let mg = this.get(d.id)
      if (mg) {
        mg.unlocked = d.unlocked

        d.levels.forEach(level_data => {
          let l = mg.getLevel(level_data.id)
          if (l) {
            l.stars = level_data.stars
            l.unlocked = level_data.unlocked
            l.playCount = level_data.playCount
          }
        })
      }
    })
  }*/
}

export default new Minigames()
